import React, { useContext, useRef, useState } from "react";
import { imageURL } from "../../../constants";
import MinisterComponent from "./MinisterComponent";
import Welcome from "./Welcome";
import Notices from "./Notices";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";
import DrtCaseCauseParent from "./DrtCaseCauseParent/DrtCaseCauseParent";
import WhatsNew from "./WhatsNew/WhatsNew";
import { DrtContext } from "../../../context/DrtContext";
import ExternalLinkPopup from "../../../services/ExternalLinkPopup";
import { useTitle } from "../../../services/PageTitle";
import LatestNews from "./LatestNews";
import HomeSlider from "./HomeSlider";

const Home = () => {
  useTitle("DRATs");

  const {
    externalLink,
    source,
    setSource,
    setExternalLink,
    setExternalLinkPopupShow,
  } = useContext(DrtContext);

  
  const sliderRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  const handlePause = () => {
    sliderRef.current?.slickPause();
    setIsPaused(true);
  };

  const handlePlay = () => {
    sliderRef.current?.slickPlay();
    setIsPaused(false);
  };
  // =========================================

  const settings = {
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <div className="homepage">
        {/* === Main Landmark === */}
        <main role="main" className="homecontent-sec">
          <h1 className="visually-hidden">
            Debts Recovery Appellate Tribunals (DRATs) and Debts Recovery Tribunals (DRTs)
          </h1>

          <div className="main-bg">
            <div className="container pt-4">
              <div className="sub-bg">
                <div className="row w-100 align-items-center">
                  <LatestNews />
                  <MinisterComponent />
                </div>
              </div>

              <HomeSlider />

              <div className="sub-bg2">
                <div className="row">
                  <DrtCaseCauseParent />
                  <WhatsNew />
                </div>
              </div>
            </div>
          </div>

          <Welcome />
          <Notices />
        </main>

        {/* === Footer Landmark === */}
        <footer className="site-footer">
          <section className="bottom-slide">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <ul>
                    <li>
                      <NavLink to="/gallery">
                        <span>
                          <img src={`${imageURL}/gallery.png`} alt="gallery" />
                        </span>
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/tender">
                        <span>
                          <img src={`${imageURL}/tender.png`} alt="tender" />
                        </span>
                        Tender
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/actnrule">
                        <span>
                          <img src={`${imageURL}/act.png`} alt="act" />
                        </span>
                        Acts & Rules
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/downloads">
                        <span>
                          <img src={`${imageURL}/download.png`} alt="download" />
                        </span>
                        Downloads
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/usefullink">
                        <span>
                          <img src={`${imageURL}/links.png`} alt="links" />
                        </span>
                        Useful Links
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/organizationalstructure">
                        <span>
                          <img src={`${imageURL}/organization-icon.png`} alt="organizational structure" />
                        </span>
                        Organizational Structure
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="gray-bg" role="contentinfo">
            <div className="container">
              <div className="row mt-3">
                <div className="col-12">
                  <div id="footer-gov1" className="govlink-carousel">
                   <div
  className="slider-controls"
  
>
  <button
    onClick={isPaused ? handlePlay : handlePause}
    className="btn pause"
    aria-pressed={isPaused}
    aria-label={!isPaused ? "Pause footer slider" : "Play footer slider"}
  >
    {!isPaused ? (
      <span>
        <i className="fas fa-pause-circle"></i> Pause
      </span>
    ) : (
      <span>
        <i className="fas fa-play"></i> Play
      </span>
    )}
  </button>
</div>
                    <Slider {...settings} ref={sliderRef}>
                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://india.gov.in/");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src={`${imageURL}/f1.png`} alt="india gov" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://goidirectory.nic.in");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src={`${imageURL}/f2.png`} alt="goi directory" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://data.gov.in/");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src="images/f3.png" alt="data gov" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://www.makeinindia.com/");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src={`${imageURL}/f4.png`} alt="make in india" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://mygov.in/");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src={`${imageURL}/f5.png`} alt="mygov" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink(
                            "https://financialservices.gov.in/beta/en"
                          );
                          setSource("Home.jsx");
                        }}
                      >
                        <img src="images/f6.png" alt="financial services" />
                      </a>

                      <a
                        className="external-link"
                        onClick={() => {
                          setExternalLinkPopupShow(true);
                          setExternalLink("https://igod.gov.in/");
                          setSource("Home.jsx");
                        }}
                      >
                        <img src={`${imageURL}/igodlogo.png`} alt="iGod" />
                      </a>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </footer>

        {externalLink !== "" && source === "Home.jsx" && <ExternalLinkPopup />}
      </div>
    </>
  );
};

export default Home;
